import styled from "styled-components";

export const PanelRow = styled.div<{ minHeight?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
`;

export const SmallText = styled.p`
  font-weight: 600;
  font-size: 13px;
  line-height: 1.4;
  color: var(--mode-text-neutral-weakest);
  margin: 0;
`;
